import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';

// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/font-awesome.min.css';
import '../css/app.css';
import '../css/locker.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';

// Register service worker for PWA (must be HTTPS in production)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
      .catch(function (err) { console.warn('SW registration failed:', err); });
  });
}

var baseURL = "https://api.digitalmoneyexpress.com/"; // Base URL for API requests, update this to your server URL
window.baseURL = baseURL; // expose for .f7.html component scripts (which don't share module scope)
// Reusable OTP resend cooldown — disables a resend link and counts down "Resend in Ns".
window.otpCooldown = function (el, seconds) {
  if (!el) return;
  seconds = seconds || 30;
  if (el.getAttribute('data-cd-base') == null) {
    el.setAttribute('data-cd-base', (el.textContent || 'Resend code').trim());
  }
  var base = el.getAttribute('data-cd-base');
  if (el._cdTimer) clearInterval(el._cdTimer);
  var left = seconds;
  var render = function () {
    if (left <= 0) {
      clearInterval(el._cdTimer); el._cdTimer = null;
      el.classList.remove('otp__resend--off');
      el.textContent = base;
      return;
    }
    el.classList.add('otp__resend--off');
    el.textContent = 'Resend in ' + left + 's';
    left--;
  };
  render();
  el._cdTimer = setInterval(render, 1000);
};
const app_ver = '1.0.1'; // App version, update this for new releases
const environment = 'dev'; // Set to 'production' for live environment, 'development' for testing
var app = new Framework7({
  root: '#app', // App root element
  id: 'app.digimoneyexpress.com', // App bundle ID
  name: 'Digi Money Express', // App name
  theme: 'md', // Automatic theme detection
  //app pushstate
  view: {
    pushState: true,
    pushStateSeparator: '#!',
    pushStateOnLoad: true,
    preloadPreviousPage: false,
  },
  smartSelect: {
    closeOnSelect: true,
  },
  sheet: {
    closeByBackdropClick: false
  },
  // App root methods
  methods: {
    initImageUpload: function(box) {
      let uploadField = box.querySelector('.image-upload');
        
        uploadField.addEventListener('change', getFile);
      
        function getFile(e){
          let file = e.currentTarget.files[0];
          checkType(file);
        }
        
        function previewImage(file){
          let thumb = box.querySelector('.js--image-preview'),
              reader = new FileReader();
      
          reader.onload = function() {
            thumb.style.backgroundImage = 'url(' + reader.result + ')';
          }
          reader.readAsDataURL(file);
          thumb.className += ' js--no-default';
        }
      
        function checkType(file){
          let imageType = /image.*/;
          //var size=(file.size)/1000;
          if (!file.type.match(imageType)) {
            app.toast.show({
              text: 'This is not an Image!',
              closeTimeout: 3000,
            });
            throw 'This is not an image';
          } else if (!file){
            app.toast.show({
              text: 'No file found!',
              closeTimeout: 3000,
            });
            throw 'No file found';
          } else {
            previewImage(file);
          }
        }
    },
    initDropEffect: function(box) {
      let area, drop, areaWidth, areaHeight, maxDistance, dropWidth, dropHeight, x, y;
          
      // get clickable area for drop effect
      area = box.querySelector('.js--image-preview');
      area.addEventListener('click', fireRipple);
      
      function fireRipple(e){
        area = e.currentTarget
        // create drop
        if(!drop){
          drop = document.createElement('span');
          drop.className = 'drop';
          this.appendChild(drop);
        }
        // reset animate class
        drop.className = 'drop';
        
        // calculate dimensions of area (longest side)
        areaWidth = getComputedStyle(this, null).getPropertyValue("width");
        areaHeight = getComputedStyle(this, null).getPropertyValue("height");
        maxDistance = Math.max(parseInt(areaWidth, 10), parseInt(areaHeight, 10));
    
        // set drop dimensions to fill area
        drop.style.width = maxDistance + 'px';
        drop.style.height = maxDistance + 'px';
        
        // calculate dimensions of drop
        dropWidth = getComputedStyle(this, null).getPropertyValue("width");
        dropHeight = getComputedStyle(this, null).getPropertyValue("height");
        
        // calculate relative coordinates of click
        // logic: click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center
        x = e.pageX - this.offsetLeft - (parseInt(dropWidth, 10)/2);
        y = e.pageY - this.offsetTop - (parseInt(dropHeight, 10)/2) - 30;
        
        // position drop and animate
        drop.style.top = y + 'px';
        drop.style.left = x + 'px';
        drop.className += ' animate';
        e.stopPropagation();
        
      }
    },
    initFileUpload: function() {
      var inputs = document.querySelectorAll( '.inputfile' );
        Array.prototype.forEach.call( inputs, function( input )
        {
          var label	 = input.nextElementSibling,
            labelVal = label.innerHTML;

          input.addEventListener( 'change', function( e )
          {
            var fileName = '';
            if( this.files && this.files.length > 1 )
              fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
            else
              fileName = e.target.value.split( '\\' ).pop();

            if( fileName )
              label.querySelector( 'span' ).innerHTML = fileName;
            else
              label.innerHTML = labelVal;
          });
        });
    },
    getPIN: function(pincode, success, error) {
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://pincode.p.rapidapi.com/",
        "method": "POST",
        "headers": {
          "x-rapidapi-host": "pincode.p.rapidapi.com",
          "x-rapidapi-key": "d52c228c20msh28eb4e495fba18ep1836f6jsn44bce943016f",
          "content-type": "application/json",
          "accept": "application/json"
        },
        "processData": false,
        "data": "{\"searchBy\":\"pincode\",\"value\":"+pincode+"}"
      }
      
      $.ajax(settings).done(function (response) {
        if(response.length === 0) {
          error("no places found");
        }
        else {
          success(response);
        }
      });
    },
    getJSON: function( url, callback) {
      $.getJSON(url, function(data) {
        callback(data);
      });
    },
    request: function( url, data, datatype, beforesend, success, error) {
      $.ajax({
        url: url,
        data: data,
        cache: false,
        dataType: datatype,
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
          beforesend();
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    post: function( url, data, datatype, beforesend, success, error) {
      $.ajax({
        url: url,
        data: data,
        cache: false,
        dataType: datatype,
        type: 'POST',
        mimeType: "multipart/form-data",
        contentType: false,
        processData: false,
        crossDomain : true,
        beforeSend: function() {
          beforesend();
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    getUserData: function(success, error) {
      $.ajax({
        url: baseURL+'v1/ajaxAuthentication.php',
        data: {userinfo: true, token: localStorage.getItem('authToken'), 'uuid': localStorage.getItem('uuid')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getUserDataInvest: function(success, error) {
      $.ajax({
        url: baseURL+'v1/invest.php',
        data: {investInfo: true, token: localStorage.getItem('authToken')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getBank: function(success, error) {
      $.ajax({
        url: baseURL+'v1/ajaxAuthentication.php',
        data: {getbank: true},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {},
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    getSettings: function(success, error) {
      $.ajax({
        url: baseURL+'v1/ajaxAuthentication.php',
        data: {getSettings: true},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {},
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    random_color: function() {
      var letters = '0123456789ABCDEF';
      var color = '';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    addComma: function(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  // App routes
  routes: routes,
  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    overlay: Framework7.device.cordova && Framework7.device.ios || 'auto',
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  on: {
    init: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
      }
    },
    //APP PAGE INIT
    pageInit: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
        //push notifications
        document.addEventListener('deviceready', OneSignalInit, false);
        function OneSignalInit() {
            // Uncomment to set OneSignal device logging to VERBOSE  
            // window.plugins.OneSignal.setLogLevel(6, 0);
            
            // NOTE: Update the setAppId value below with your OneSignal AppId.
            window.plugins.OneSignal.setAppId("99ff4514-ef4f-488b-b853-942b3209e23b");
            window.plugins.OneSignal.setNotificationOpenedHandler(function(jsonData) {
              console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
            });
            //Prompts the user for notification permissions.
              //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
              window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
                console.log("User accepted notifications: " + accepted);
            });
            var deviceID = device.uuid;
            window.plugins.OneSignal.setExternalUserId(deviceID);
            localStorage.setItem('uuid', deviceID);
            //console.log(deviceID);
        }
      }
      // Desktop / DevTools protection (production only)
      if (environment == 'production') {
        // 1) Activate the desktop / large-screen guard overlay (static markup in
        //    index.html). Visibility is driven by CSS (body.is-prod .dtg + @media
        //    + body.is-desktop), so it stays responsive without destroying the
        //    page or reloading.
        document.body.classList.add('is-prod');
        // Flag genuine desktop devices (no touch) so the guard also shows on a
        // small desktop window, not just wide viewports.
        var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        if (!isTouch) document.body.classList.add('is-desktop');

        // 2) Deter DevTools — bound once (this pageInit runs on every navigation).
        //    Note: these are deterrents only; they cannot truly prevent inspection.
        if (!window.__devGuardInit) {
          window.__devGuardInit = true;
          document.addEventListener('keydown', function (event) {
            var k = event.keyCode || event.which;
            var ctrl = event.ctrlKey || event.metaKey;
            if (
              k === 123 ||                                            // F12
              (ctrl && event.shiftKey && (k === 73 || k === 74 || k === 67)) || // Ctrl/Cmd+Shift+I / J / C
              (ctrl && k === 85)                                      // Ctrl+U (view source)
            ) {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
          }, true);
          document.addEventListener('contextmenu', function (e) { e.preventDefault(); }, true);
        }
      }
      checkMaintenance();
      function checkMaintenance() {
        $.getJSON(baseURL+'v1/settings.json', function(data) {
          //check setting if maintenance is true or false
          if (data.maintenance) {
            $$('.page-content').empty();
            $$('.page-content').css({'background':'#0A0A0B','display':'flex','flex-direction':'column','align-items':'center','justify-content':'center','min-height':'100vh','padding':'32px 24px'});
            $$('.page-content').append(
              '<div style="text-align:center;max-width:340px;width:100%;">'+
                '<div style="width:110px;height:110px;border-radius:50%;background:linear-gradient(135deg,#2a1f0a 0%,#1a1400 100%);border:2px solid rgba(223,194,136,0.25);display:flex;align-items:center;justify-content:center;margin:0 auto 28px;box-shadow:0 0 40px rgba(223,194,136,0.10);">'+
                  '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#dfc288" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'+
                '</div>'+
                '<h2 style="color:#dfc288;font-size:22px;font-weight:700;margin:0 0 10px;letter-spacing:0.3px;">Under Maintenance</h2>'+
                '<div style="width:40px;height:3px;background:linear-gradient(90deg,transparent,#dfc288,transparent);border-radius:2px;margin:0 auto 18px;"></div>'+
                '<p style="color:rgba(255,255,255,0.6);font-size:14px;line-height:1.7;margin:0 0 32px;">'+data.maintenance_message+'</p>'+
                '<div style="background:rgba(223,194,136,0.07);border:1px solid rgba(223,194,136,0.15);border-radius:12px;padding:16px 20px;display:flex;align-items:center;gap:12px;">'+
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#dfc288" stroke-width="1.8" stroke-linecap="round"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M12 6v6l4 2"/></svg>'+
                  '<span style="color:rgba(255,255,255,0.5);font-size:13px;">We\'ll be back shortly. Thank you for your patience.</span>'+
                '</div>'+
              '</div>'
            );
            $$('.navbar').hide();
            $$('.toolbar-bottom').hide();
            $$('.panel-open').remove();
          }
        });
      }
      //app version
      $$('.app-version').html(app_ver);
      //check if user is terminated
      f7.methods.getUserData(function(data) {
        if(data.status == 'blocked') {
          app.views.current.router.navigate({name: 'Home'});
          localStorage.removeItem('authToken');
          localStorage.removeItem('phone');
          localStorage.removeItem('isloggedIN');
          localStorage.removeItem('payment');
          app.popup.close('#profile-popup');
          $$('.login-link').attr('href','/login/');
          $$('.login-link').removeClass('logout');
          $$('.login-link').html('Login');
          $$('.profile-link').attr('href','/login/');
          $$('.profile-link').removeClass('popup-open');
          $$('.profile-link').removeAttr('data-popup');
          f7.toast.show({
            text: 'Your account is terminated and logged out from this device!',
            closeTimeout: 3000,
          });
        }
      });
      //logout
      $$(document).off('click', '.logout');
      $$(document).on('click', '.logout' ,function() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('phone');
        localStorage.removeItem('isloggedIN');
        app.popup.close('#profile-popup');
        var router = app.views.current.router;
        router.navigate(router.currentRoute.url, {
          reloadCurrent: true,
          ignoreCache: true,
        });
        $$('.profile-link').attr('href','/login/');
        $$('.profile-link').removeClass('popup-open');
        $$('.profile-link').removeAttr('data-popup');
        f7.toast.show({
          text: 'Logged out from this device!',
          closeTimeout: 3000,
        });
      })
      // Start the resend cooldown when an OTP popup opens (a code was just sent)
      $$(document).off('popup:open.otpcd').on('popup:open.otpcd', '.sheet-OTP--verification, .sheet-forget--otp', function() {
        var link = this.querySelector('.resendOTPac');
        if (link) window.otpCooldown(link, 30);
      });
      // Populate profile popup whenever it opens, from any page
      $$(document).off('popup:open', '#profile-popup').on('popup:open', '#profile-popup', function() {
        f7.methods.getUserData(function(data) {
          if (data.isLoggedin != 'true') return;
          if (data.referralCode) {
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          }
          $$('.profile-name').html(data.name);
          $$('.loggeninProfileUI').attr('src', 'https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=' + encodeURIComponent(data.name));
          $$('.profile-email').html(data.email);
          $$('.profile-phone').html(data.phone);
          $$('.profile-address').html(data.address);
          $$('.profile-dob').html(data.dob);
          $$('.profile-country').html(data.country || '—');
          $$('.profile-dialcode').html(data.dialCode || data.dial_code || data.countryCode || data.phonecode || '—');
          f7.methods.request(baseURL + 'v1/kyc.php', { kycStatus: 1, token: localStorage.getItem('authToken') }, 'json',
            function() {},
            function(res) {
              if (!res || res.status !== 'success') return;
              var st = res.kycStatus === 'not_submitted' ? 'none' : (res.kycStatus || 'none');
              var map = {
                approved: { txt: 'Verified',     sub: 'Your identity is verified — withdrawals enabled' },
                pending:  { txt: 'Under review', sub: 'Your documents are being reviewed' },
                rejected: { txt: 'Rejected',     sub: 'Verification failed — tap to resubmit' },
                none:     { txt: 'Not started',  sub: 'Verify your identity to enable withdrawals' }
              };
              var m = map[st] || map.none;
              $$('.pp__kyc-status').removeClass('pp__kyc-status--approved pp__kyc-status--pending pp__kyc-status--rejected pp__kyc-status--none').addClass('pp__kyc-status--' + st);
              $$('.pp__kyc-status-txt').html(m.txt);
              $$('.pp__kyc-sub--text').html(m.sub);
            },
            function() {});
        });
      });

      //OTP verification
      $(document).off('click', '.acBTNotp');
      $(document).on('click','.acBTNotp',function(){
        if (!$$('#ac-otp')[0].checkValidity()) {
          console.log('Check Validity!');
        } else {
          OTPverification();
        }
      });
      function OTPverification() {
        var value = $$('#ac-otp').val();
        app.methods.request(
          baseURL+'v1/ajaxAuthentication.php',
          {OTPver: true, mobile: localStorage.getItem('phone'), OTP: value},
          'json',
          function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
          function(data) {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            if(data.status == 'success') {
              app.toast.show({
                text: 'Logged in successfully!',
                closeTimeout: 3000,
              });
              app.popup.close('.sheet-OTP--verification');
              localStorage.setItem('authToken', data.token);
              localStorage.setItem('isloggedIN', true);
              localStorage.setItem('country', data.country);
              localStorage.removeItem('phone');
              setTimeout(() => {
                var view = app.views.current;
                view.router.navigate('/');
                app.dialog.close();
              }, 1000);
            }
            else {
              app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
            }
          },
          function() {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            app.toast.show({
                  text: 'No internet connection!',
                  closeTimeout: 3000,
                });
          }
        );
      }
      //resend otp
      $(document).off('click', '.resendOTPac');
      $(document).on('click', '.resendOTPac', function() {
        if (this.classList.contains('otp__resend--off')) return; // on cooldown
        var type = $$(this).data('type');
          if(type == 'account') {
            var phone = localStorage.getItem('phone');
          } else if(type == 'forgetpass') {
            var phone = $$('#fp-username').val();
          } else {

          }
        window.otpCooldown(this, 30); // start cooldown on this resend link
        app.methods.request(baseURL+'v1/ajaxAuthentication.php',
        {OTPresend: true, phone: phone, type: type},
        'json',
        function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
        function(data) {
          $$('.button').removeClass('disabled');
          app.dialog.close();
          if(data.status == 'success') {
            app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
          }
          else {
            app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
          }
        },
        function() {
          $$('.button').removeClass('disabled');
          app.dialog.close();
          app.toast.show({
            text: 'Failed to Connect',
            closeTimeout: 3000,
          });
        }
        );
      });
    },
  },
});
/* PWA services worker register */
// Register the service worker only in a real browser PWA context (secure origin),
// not inside the Cordova WebView (file://) where it can't register.
if ("serviceWorker" in navigator &&
    (location.protocol === "https:" || location.hostname === "localhost" || location.hostname === "127.0.0.1")) {
  window.addEventListener("load", function () {
      // Served from the ROOT → scope defaults to "/" (controls the whole app).
      navigator.serviceWorker
          .register("/service-worker.js")
          .then(function (reg) {
              console.log("service worker registered, scope:", reg.scope);
          })
          .catch(function (err) {
              console.log("service worker not registered", err);
          });
  });
}
/* PWA add to home button */
var defferedPrompt;
// Modern install sheet modal (replaces the old tiny-button notification)
var pwaInstallSheet = app.sheet.create({
    el: '#pwa-install-sheet',
    swipeToClose: true,
    on: {
      closed: function () {
        localStorage.setItem('pwaPromptDismissed', JSON.stringify({
          dismissed: true,
          time: new Date().toLocaleString(),
        }));
        console.log('PWA prompt dismissed');
      },
    },
});
// Install button → trigger the native A2HS prompt
$(document).off('click', '#install-pwa').on('click', '#install-pwa', function () {
    if (defferedPrompt) {
        defferedPrompt.prompt();
        defferedPrompt.userChoice.then(function (choiceResult) {
            console.log(choiceResult.outcome === 'accepted' ? 'User accepted the A2HS prompt' : 'User dismissed the A2HS prompt');
            defferedPrompt = null;
        });
    }
    pwaInstallSheet.close();
});
// Check if the app is already installed
function isAppInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches || 
          window.navigator.standalone ||
          document.referrer.includes('android-app://');
}

// Check if user has previously dismissed the prompt
function hasDismissedPrompt() {
  //check if it's dismissed 1 hour ago
  const pwaPromptDismissed = localStorage.getItem('pwaPromptDismissed');
  if (pwaPromptDismissed) {
    const { dismissed, time } = JSON.parse(pwaPromptDismissed);
    if (dismissed) {
      const dismissedTime = new Date(time);
      const currentTime = new Date();
      const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
      // Check if the prompt was dismissed more than 1 hour ago
      if (currentTime - dismissedTime > oneHour) {
        // If more than 1 hour has passed, allow the prompt to be shown again
        localStorage.removeItem('pwaPromptDismissed');
        return false;
      }
      // If less than 1 hour has passed, do not show the prompt again
      return true;
    } else {
      return false;
    }
  }
  return false;
}
// Check if app is already installed on page load
if (isAppInstalled()) {
    console.log('App is already installed');
}
window.addEventListener("beforeinstallprompt", function (event) {
    event.preventDefault();
    defferedPrompt = event;
    console.log("beforeinstallprompt fired");
    // Show the modern install sheet (button click handled globally above)
    if(!hasDismissedPrompt() && !isAppInstalled()) {
      pwaInstallSheet.open();
    } else {
      console.log('PWA prompt dismissed or app already installed');
    }
});

window.addEventListener("appinstalled", function (event) {
    console.log("app installed");
    defferedPrompt = null;
    if (pwaInstallSheet) pwaInstallSheet.close();
    console.log("app installed", event);
});
